import { fuzzySearch } from '@/utils/fuzzySearch';
import _ from 'lodash';

// Fuzzy-matches an already-filtered option list against the text the user typed.
// Sentinel options stand in for buttons and group headers rather than selectable
//  values, so they have no label to match against: they are held out of the
//  search and appended to the matches.
export const fuzzyFilterOptions = <Option>({
    options,
    typedText,
    isSentinel,
    optionToLabel,
}: {
    options: Option[];
    typedText: string;
    isSentinel: (option: Option) => boolean;
    optionToLabel: (option: Option) => string;
}): Option[] => {
    // Fuzzy matching returns nothing if the input is empty, so handle this as a
    //  special case and leave the list untouched.
    if (!typedText) {
        return options;
    }

    const [sentinels, labeledOptions] = _.partition(options, isSentinel);

    return [
        ...fuzzySearch(
            typedText,
            labeledOptions.map((option) => ({
                obj: option,
                key: optionToLabel(option),
            })),
        ),
        ...sentinels,
    ];
};
